import React from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftContentRightImg from "../../Components/sub-pages/Left-content-right-image";
import { Container } from "react-bootstrap";
import NogapleftImg from "../../Components/sub-pages/NogapleftImg";
import DynamicFaqs from "../../Components/home/Faqs";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";

const Joiningkits = () => {
  const CTAContent = [
    {
      pageName: "Joining Kits",
      paragraphitalic: "The Perfect Start to a New Journey",
      paragraphText: (
        <>
          <p>
            Joining a new company is a special moment filled with anticipation,
            excitement, and a little bit of nervous energy. A thoughtfully
            designed new joinee kit turns that first day into a memorable brand
            experience.
          </p>
          <p>
            At eYantra, we help organizations create employee joining kits that
            embody their culture, values, and professionalism. Whether it's a
            start-up welcoming new hires or a global enterprise onboarding at
            scale, our custom new joinee kits ensure that every employee feels
            instantly connected and appreciated from day one.
          </p>
        </>
      ),
      ContactFormName: "Joining Kits",
    },
  ];

  const SubpgesLeftContent = [
    {
      index: 0,
      sectionName: "Why New Joinee Kits Matter",
      sectionparagraphText: (
        <>
          <p>
            The first impression sets the tone for an employee's entire journey.
            A well-curated joining kit for new employees does more than
            distribute company essentials it communicates belonging, care, and
            identity.
          </p>
          <p>
            Today, companies are realizing that onboarding is not just a
            formality but a powerful brand moment. A new joinee kit bridges the
            emotional gap between joining and belonging.
          </p>
          <p>
            When an employee opens a beautifully packaged kit that includes
            branded merchandise, essential tools, and a personal note it tells
            them:
          </p>
          <p>“You're valued here. You're part of our story.”</p>
        </>
      ),
      ImgSrc:
        "../assests/images/Joining Kits/Why New joinee kits matter.png",
    },
    {
      index: 1,
      sectionName: "What's Inside an Ideal New Joinee Kit?",
      sectionparagraphText: (
        <>
          <p>
            Every organization is unique, but here's a glimpse of what our most
            popular employee joiningkits include:
          </p>
        </>
      ),
      ImgSrc:
        "../assests/images/Joining Kits/Whats inside.png",
      CategoriesLeftContent: [
        {
          CategoryImg: "../assests/images/Joining Kits/Custom Messaging.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Welcome Letter & Handbook</b>
              </p>
            </>
          ),
        },
        {
          CategoryImg: "../assests/images/Joining Kits/Eco-friendly Products.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Eco-Friendly Products</b>
              </p>
            </>
          ),
        },
        {
          CategoryImg:
            "../assests/images/Joining Kits/High-Quality Materials.png",
          CategoryName: (
            <>
              <p className="fs-14">
                <b>Stationery Essentials</b>
              </p>
            </>
          ),
        },
      ],
    },
    {
      index: 2,
      sectionName: "How We Create the Perfect Employee Joining Kit?",
      parapgraphItalic:
        "Our process is simple yet meticulous ensuring every box reflects your brand promise.",

      ImgSrc:
        "../assests/images/Joining Kits/How we create.png",
      ListContent: [
        {
          ListHeading: "Understanding Your Brand",
          ListParagraph:
            "We begin with your story company culture, tone, and visual identity.",
        },
        {
          ListHeading: "Curate & Customize",
          ListParagraph:
            "Our creative team shortlists products that align with your vision, while our design team personalizes them with your branding.",
        },
        {
          ListHeading: "Packaging Design",
          ListParagraph:
            "Elegant, sturdy, and reusable packaging from magnetic boxes to eco-friendly kraft boxes, we make sure your presentation wows every recipient.",
        },
        /*  {
          ListHeading: "Approval & Prototyping",
          ListParagraph: "We share digital mockups and physical samples before production for your approval.",
        }, */
      ],
    },
  ];

  const noGapContent = [
    {
      RightImgNogap:
        "../assests/images/Joining Kits/Why Choose eYantra.png",
      NogapHeading: "Why Choose eYantra for Your Employee Joining Kits?",
      paragraphDetail: (
        <>
          <p>
            We've been crafting corporate onboarding and joining kits for
            overtwo decades, helping 3,000+ organizations build stronger
            employee connections from day one.
          </p>
          {/* <p>Here's what sets us apart:</p> */}
        </>
      ),
      Heading: [
        // {
        //   ListHeading: "Complete Customization",
        //   ListParagraph:
        //     "From box design to product selection, every element of your new joinee kit is customizable. Choose your own colors, logos, welcome notes, and internal branding to reflect your company's unique personality.",
        // },
        
        {
          ListHeading: "Premium Quality Products",
          ListParagraph:
            "We curate high-quality items that employees actually use and cherish from branded apparel and gadgets to eco-friendly stationery and drinkware.",
        },
        {
          ListHeading: "End-to-End Service",
          ListParagraph:
            "We handle everything concept, curation, printing, packaging, and pan-India delivery. Whether you're onboarding 10 employees or 10,000, our logistics network ensures consistency and care.",
        },
        {
          ListHeading: "Sustainable Choices",
          ListParagraph:
            "Through our ecoR'us initiative, we offer eco-conscious alternatives bamboo pens, cork notebooks, jute bags, and recyclable packaging because every small choice counts toward a greener planet.",
        },
        {
          ListHeading:"Personal Touches",
          ListParagraph:"Include personalized welcome cards, employee name tags, or onboarding messages signed by leadership small gestures that create big emotional impact."

        }
      ],
    },
    {
      RightImgNogap:
        "../assests/images/Joining Kits/Types of New joinee kits.png",
      NogapHeading: "Types of New Joinee Kits We Offer",
      Heading: [
        {
          ListHeading: "Corporate Joining Kits",
          ListParagraph:
            "Designed for formal workplaces includes office essentials, branded notebooks, ID cards, and accessories.",
        },
        {
          ListHeading: "IT & Startup Onboarding Kits",
          ListParagraph:
            "Trendy and tech-savvy kits that include gadgets, apparel, and fun elements reflecting modern work culture.",
        },
        {
          ListHeading: "Eco-Friendly Kits",
          ListParagraph:
            "All items made from sustainable, reusable, or biodegradable materials. Ideal for brands that value green practices.",
        },
        {
          ListHeading: "Remote Employee Joining Kits",
          ListParagraph:
            "Perfect for hybrid or WFH models shipped directly to employee homes with personalized branding.",
        },
      ],
    },
    {
      RightImgNogap:
        "../assests/images/Joining Kits/Benefits of Giving.png",
      NogapHeading: "Benefits of Giving New Joinee Kits",
      Heading: [
        {
          ListHeading: "Builds Instant Belonging",
          ListParagraph:
            "Employees feel valued and included right from their first day.",
        },
        {
          ListHeading: "Strengthens Employer Branding",
          ListParagraph:
            "Your logo and values become part of their daily life, reinforcing your brand identity.",
        },
        {
          ListHeading: "Enhances Productivity",
          ListParagraph:
            "Employees receive the essentials they need to begin work comfortably.",
        },
        {
          ListHeading: "Boosts Retention &amp; Engagement",
          ListParagraph:
            "A strong emotional connection from day one leads to higher morale and retention.",
        },
        {
          ListHeading: "Reflects Professionalism",
          ListParagraph:
            "A curated, branded joining kit for employees shows that your company values organization and presentation.",
        },
      ],
    },
  ];

  const faqsData = [
    {
      question: "What should a new joinee kit include?",
      answer:
        "A new joinee kit typically includes branded merchandise, stationery, tech accessories, welcome letters, and employee handbooks. Some companies also include personalized gifts or eco-friendly items.",
    },
    {
      question: "Why are new joinee kits important?",
      answer:
        "They create a strong first impression, foster engagement, and help new employees feel connected to the company culture from their first day.",
    },
    {
      question: "Can I customize the joining kit for my employees?",
      answer:
        "Yes! eYantra specializes in fully customized employee joining kits with your logo, colors, and messaging designed to match your brand identity.",
    },
    {
      question: "Do you offer sustainable or eco-friendly options?",
      answer:
        "Absolutely. We offer eco-friendly joining kits made from bamboo, cork, and recycled materials with biodegradable packaging.",
    },
    {
      question: "What's the minimum order quantity for new joinee kits?",
      answer:
        "You can start with small batches (as few as 25 kits) or scale to thousands our flexible system supports all organization sizes.",
    },
    {
      question: "How long does production and delivery take?",
      answer:
        "Typically, we deliver within 10 - 15 working days depending on customization and quantity.",
    },
    {
      question: "Can you deliver kits to remote or WFH employees?",
      answer:
        "Yes, we ship directly to employee addresses across India and internationally, making remote onboarding seamless.",
    },
    {
      question: "What kind of packaging do you offer?",
      answer:
        "We offer luxury magnetic boxes, eco kraft boxes, sleeves, and reusable tote-style boxes all customizable with your branding.",
    },
    {
      question: "Do you include personalized letters or onboarding documents?",
      answer:
        "Yes, we can insert personalized cards, HR documents, ID cards, and company guides into each box.",
    },
    {
      question: "Are new joinee kits tax-deductible for companies?",
      answer:
        "In many cases, yes. Corporate gifts and onboarding materials are often categorized under employee welfare or HR expenses.",
    },
    {
      question: "What's the average budget for a new joinee kit?",
      answer:
        "It depends on your content basic kits start around ₹700 - ₹1,000 per employee, while premium versions with gadgets and apparel can go up to ₹3,000+.",
    },
    {
      question: "How can eYantra help with bulk onboarding drives?",
      answer:
        "We provide a scalable onboarding solution — from curation to logistics — ensuring every employee across multiple locations receives their kit on time.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>New Joinee Kit | Employee Joining Kit | Custom Joining Kit for Employees – eYantra</title>
        <meta
          name="description"
          content="Discover eYantra's customized New Joinee Kits thoughtful onboarding solutions designed to
welcome new employees with style. From branded essentials to sustainable packaging, create
the perfect employee joining kit that reflects your brand and culture. Delivered pan India with full
customization."        />
        <meta
          name="keywords"
          content="new joinee kit, employee joining kit, joining kit, joining kit for employees, joining kit for new employees, corporate onboarding kit, new hire welcome kit, company joining kit, personalized employee joining kit"
        />
      </Helmet>
      <div className="p-0 m-2">
        <Ctapage data={CTAContent} />
        <Container>
          <LeftContentRightImg data={SubpgesLeftContent[0]} />
        </Container>
        <NogapleftImg data={noGapContent[0]} />
        <Container>
          <LeftContentRightImg data={SubpgesLeftContent[1]} />
        </Container>
        <NogapleftImg data={noGapContent[1]} />
        <Container>
          <LeftContentRightImg data={SubpgesLeftContent[2]} />
        </Container>
        <NogapleftImg data={noGapContent[2]} />
      </div>

      <p className="text-center fs-32 w-75 d-block m-auto py-5">
        Make their first day unforgettable with a kit that reflects your
        company's culture and commitment to employee satisfaction.
      </p>
  
      <Whychooseus/>
      
      <Container className="py-5">
        <h2>Frequently Asked Questions</h2>
        <DynamicFaqs faqsDynamicContent={faqsData} />
      </Container>
    </>
  );
};

export default Joiningkits;
